import React, { Component } from 'react';
import PageBanner from '../components/PageBanner';
import Footer from '../components/Footer';

class ShippingPolicy extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    const existing = document.getElementById('termly-jssdk');
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = 'termly-jssdk';
    script.src = 'https://app.termly.io/embed-policy.min.js';
    document.body.appendChild(script);
  }

  render() {
    return (
      <div>
        <PageBanner title='Shipping Policy' background='page-banner.jpg' />
        <div className='p-3'>
          <div
            name='termly-embed'
            data-id='407116c4-51de-44cb-a787-3ef1a474073d'
          ></div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default ShippingPolicy;
